import { render, staticRenderFns } from "./ParticipantCategoryContainer.vue?vue&type=template&id=308ac4a6&"
import script from "./ParticipantCategoryContainer.vue?vue&type=script&lang=js&"
export * from "./ParticipantCategoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports